// apps/web/src/views/public-views/play/index.js

import {
  Button,
  Checkbox,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Select,
  Typography,
  message,
} from 'antd'

import {
  useEffect,
  useMemo,
  useState,
} from 'react'

import {
  useNavigate,
  useParams,
} from 'react-router-dom'

import fetch from 'auth/FetchInterceptor'

import './play.css'

import RouletteGame from './games/roulette'
import MemoryGame from './games/memory'
import QuizGame from './games/quiz'
import GameStartScreen from './components/start-screen'

import {
  OfflineGameService,
  OfflineSpinService,
  OfflineLeadService,
  NetworkService,
} from 'offline'

const {
  Title,
} = Typography

const defaultBenefitItems = [
  {
    icon: '🎁',
    text: 'Prêmios incríveis',
  },
  {
    icon: '✨',
    text: '100% gratuito',
  },
  {
    icon: '🏆',
    text: 'Rápido e fácil',
  },
]

const API_BASE_URL =
  'https://games.nlbsolucoes.com/api'

const getImageUrl = (url) => {
  if (!url) {
    return null
  }

  if (
    url.startsWith('http')
  ) {
    return url
  }

  return `${API_BASE_URL}${url}`
}

const hexToRgb = (color) => {
  const normalized = String(
    color || '#000000',
  )
    .replace('#', '')
    .trim()

  if (
    normalized.length === 3
  ) {
    const expanded =
      normalized
        .split('')
        .map(
          (character) =>
            `${character}${character}`,
        )
        .join('')

    return hexToRgb(
      `#${expanded}`,
    )
  }

  if (
    normalized.length !== 6
  ) {
    return '0, 0, 0'
  }

  const red = parseInt(
    normalized.substring(
      0,
      2,
    ),
    16,
  )

  const green = parseInt(
    normalized.substring(
      2,
      4,
    ),
    16,
  )

  const blue = parseInt(
    normalized.substring(
      4,
      6,
    ),
    16,
  )

  if (
    [
      red,
      green,
      blue,
    ].some(
      (value) =>
        Number.isNaN(value),
    )
  ) {
    return '0, 0, 0'
  }

  return `${red}, ${green}, ${blue}`
}

const PlayPage = () => {
  const { slug } =
    useParams()

  const navigate =
    useNavigate()

  const [
    game,
    setGame,
  ] = useState(null)

  const [
    leadForm,
    setLeadForm,
  ] = useState(null)

  const [
    leadId,
    setLeadId,
  ] = useState(null)

  const [
    leadValues,
    setLeadValues,
  ] = useState(null)

  const [
    loading,
    setLoading,
  ] = useState(false)

  const [
    loadingLead,
    setLoadingLead,
  ] = useState(false)

  const [
    spinning,
    setSpinning,
  ] = useState(false)

  const [
    showCenterLogo,
    setShowCenterLogo,
  ] = useState(false)

  const [
    showLeadAfterGame,
    setShowLeadAfterGame,
  ] = useState(false)

  const [
    showStartScreen,
    setShowStartScreen,
  ] = useState(true)

  const [
    rotation,
    setRotation,
  ] = useState(0)

  const [
    leadCaptureForm,
  ] = Form.useForm()

  const prizes =
    useMemo(() => {
      return game?.prizes?.length
        ? game.prizes
        : []
    }, [game])

  // ======================================================
  // RESET PARTICIPANTE
  // ======================================================

  const resetParticipant = () => {
    if (game?.id) {
      localStorage.removeItem(
        `game_${game.id}_lead_id`,
      )

      localStorage.removeItem(
        `game_${game.id}_lead_values`,
      )

      sessionStorage.removeItem(
        `game_${game.id}_show_lead_after`,
      )

      sessionStorage.removeItem(
        `game_${game.id}_last_spin_id`,
      )
    }

    setLeadId(null)

    setLeadValues(null)

    setRotation(0)

    setSpinning(false)

    setLoading(false)

    setLoadingLead(false)

    setShowCenterLogo(false)

    setShowLeadAfterGame(false)

    setShowStartScreen(
      true,
    )

    leadCaptureForm.resetFields()
  }

  // ======================================================
  // FINALIZAR PARTICIPANTE DO QUIZ
  // ======================================================

  const resetQuizParticipant = () => {
    if (!game?.id) {
      return
    }

    console.log(
      '[QUIZ] Limpando participante anterior:',
      {
        gameId: game.id,
        leadId,
      },
    )

    // ====================================================
    // STORAGE DO PARTICIPANTE
    // ====================================================

    localStorage.removeItem(
      `game_${game.id}_lead_id`,
    )

    localStorage.removeItem(
      `game_${game.id}_lead_values`,
    )

    // ====================================================
    // ESTADO DO FORMULÁRIO AFTER GAME
    // ====================================================

    sessionStorage.removeItem(
      `game_${game.id}_show_lead_after`,
    )

    sessionStorage.removeItem(
      `game_${game.id}_last_spin_id`,
    )

    // ====================================================
    // ESTADO REACT
    // ====================================================

    setLeadId(null)

    setLeadValues(null)

    setShowLeadAfterGame(false)

    setLoadingLead(false)

    leadCaptureForm.resetFields()

    console.log(
      '[QUIZ] Participante limpo. Próxima participação exigirá novo cadastro.',
    )
  }

  // ======================================================
  // ENTRAR NO JOGO
  // ======================================================

  const handleEnterGame =
    () => {
      setShowStartScreen(
        false,
      )

      window.dispatchEvent(
        new CustomEvent(
          'games:idle-pause',
        ),
      )
    }

  // ======================================================
  // TIMEOUT PARA API
  // ======================================================

  const fetchWithTimeout = async (
    config,
    timeout = 2500,
  ) => {
    return Promise.race([
      fetch(config),

      new Promise(
        (
          _,
          reject,
        ) => {
          window.setTimeout(
            () => {
              reject(
                new Error(
                  'API_TIMEOUT',
                ),
              )
            },
            timeout,
          )
        },
      ),
    ])
  }

  // ======================================================
  // CARREGAR FORMULÁRIO
  // ======================================================

  const loadLeadForm = async (
    gameId,
  ) => {
    let formData = null

    try {
      const apiOnline =
        await NetworkService
          .checkApiConnection()

      console.log(
        '[HYBRID] API REAL FORMULÁRIO:',
        apiOnline
          ? 'ONLINE'
          : 'OFFLINE',
      )

      if (apiOnline) {
        try {
          formData =
            await fetchWithTimeout(
              {
                url:
                  `/public/games/${gameId}/lead-form`,

                method:
                  'get',

                silentNetworkError:
                  true,
              },
              2500,
            )

          await OfflineGameService
            .saveLeadForm(
              gameId,
              formData ||
              null,
            )

          console.log(
            '[HYBRID] Formulário atualizado ONLINE:',
            gameId,
          )
        } catch (
        onlineError
        ) {
          console.warn(
            '[HYBRID] API do formulário indisponível. Tentando IndexedDB...',
            onlineError,
          )
        }
      } else {
        console.log(
          '[HYBRID] API real indisponível. Pulando API do formulário.',
        )
      }

      if (!formData) {
        formData =
          await OfflineGameService
            .getLeadForm(
              gameId,
            )

        if (formData) {
          console.log(
            '[HYBRID] Formulário carregado do IndexedDB:',
            gameId,
          )
        } else {
          console.log(
            '[HYBRID] Nenhum formulário encontrado no IndexedDB:',
            gameId,
          )
        }
      }

      setLeadForm(
        formData ||
        null,
      )

      return (
        formData ||
        null
      )
    } catch (error) {
      console.error(
        '[HYBRID] Erro ao carregar formulário:',
        error,
      )

      setLeadForm(null)

      return null
    }
  }

  // ======================================================
  // NORMALIZAR GAME
  // ======================================================

  const normalizeGame = (
    data,
  ) => ({
    ...data,

    leadCapturePosition:
      data.leadCapturePosition ||
      'BEFORE_GAME',

    wheelModel:
      data.wheelModel ||
      'MODEL_1',

    wheelPosition:
      data.wheelPosition ||
      'CENTER',

    wheelSize:
      Number(
        data.wheelSize ||
        680,
      ),

    showLogo:
      data.showLogo ??
      true,

    showTitle:
      data.showTitle ??
      true,

    showSubtitle:
      data.showSubtitle ??
      true,

    showPlayHint:
      data.showPlayHint ??
      true,

    showTopBenefits:
      data.showTopBenefits ??
      true,

    showBottomBanner:
      data.showBottomBanner ??
      false,

    disableContextMenu:
      data.disableContextMenu ??
      false,

    fullscreenEnabled:
      data.fullscreenEnabled ??
      false,

    logoVerticalPosition:
      data.logoVerticalPosition ||
      'TOP',

    logoHorizontalPosition:
      data.logoHorizontalPosition ||
      'LEFT',

    logoSize:
      Number(
        data.logoSize ||
        130,
      ),

    titleColor:
      data.titleColor ||
      data.textColor ||
      '#ffffff',

    titleFontSize:
      Number(
        data.titleFontSize ||
        48,
      ),

    titleFontWeight:
      data.titleFontWeight ||
      '950',

    subtitleColor:
      data.subtitleColor ||
      data.textColor ||
      '#ffffff',

    subtitleFontSize:
      Number(
        data.subtitleFontSize ||
        20,
      ),

    subtitleFontWeight:
      data.subtitleFontWeight ||
      '700',

    playHintText:
      data.playHintText ||
      'Clique em GIRAR para tentar a sorte!',

    playHintColor:
      data.playHintColor ||
      data.textColor ||
      '#ffffff',

    playHintFontSize:
      Number(
        data.playHintFontSize ||
        18,
      ),

    playHintFontWeight:
      data.playHintFontWeight ||
      '800',

    topBenefitsItems:
      Array.isArray(
        data.topBenefitsItems,
      )
        ? data.topBenefitsItems
        : defaultBenefitItems,

    // ==========================================
    // TELA DE ESPERA
    // ==========================================

    idleScreenEnabled:
      data.idleScreenEnabled ??
      false,

    idleScreenDelay:
      Number(
        data.idleScreenDelay ||
        30000,
      ),

    idleScreenShowBackground:
      data.idleScreenShowBackground ??
      true,

    idleScreenBackgroundUrl:
      data.idleScreenBackgroundUrl ||
      '',

    idleScreenShowVideo:
      data.idleScreenShowVideo ??
      false,

    idleScreenVideoUrl:
      data.idleScreenVideoUrl ||
      '',

    idleScreenMessage:
      data.idleScreenMessage ||
      'Toque na tela para começar',

    idleScreenMessageColor:
      data.idleScreenMessageColor ||
      '#ffffff',

    idleScreenMessageFontSize:
      Number(
        data.idleScreenMessageFontSize ||
        48,
      ),

    idleScreenMessagePosition:
      data.idleScreenMessagePosition ||
      'CENTER',

    idleScreenOverlayColor:
      data.idleScreenOverlayColor ||
      '#000000',

    idleScreenOverlayOpacity:
      Number(
        data.idleScreenOverlayOpacity ??
        20,
      ),

    // ==========================================
    // DESIGNER — TELA DO FORMULÁRIO
    // ==========================================

    formPageBackgroundUrl:
      data.formPageBackgroundUrl ||
      '',

    formPageBackgroundColor:
      data.formPageBackgroundColor ||
      data.backgroundColor ||
      '#15112f',

    formPageOverlayColor:
      data.formPageOverlayColor ||
      '#000000',

    formPageOverlayOpacity:
      Number(
        data.formPageOverlayOpacity ??
        45,
      ),

    formPageBackgroundBlur:
      Number(
        data.formPageBackgroundBlur ||
        0,
      ),

    formPageShowLogo:
      data.formPageShowLogo ??
      true,

    formPageLogoUrl:
      data.formPageLogoUrl ||
      '',

    formPageLogoSize:
      Number(
        data.formPageLogoSize ||
        180,
      ),

    formPageLogoVerticalPosition:
      data.formPageLogoVerticalPosition ||
      'TOP',

    formPageLogoHorizontalPosition:
      data.formPageLogoHorizontalPosition ||
      'CENTER',

    formPageShowTitle:
      data.formPageShowTitle ??
      true,

    formPageTitle:
      data.formPageTitle ||
      'Cadastre-se',

    formPageTitleColor:
      data.formPageTitleColor ||
      '#ffffff',

    formPageTitleFontSize:
      Number(
        data.formPageTitleFontSize ||
        32,
      ),

    formPageTitleFontWeight:
      data.formPageTitleFontWeight ||
      '800',

    formPageShowSubtitle:
      data.formPageShowSubtitle ??
      true,

    formPageSubtitle:
      data.formPageSubtitle ||
      'Preencha seus dados para participar',

    formPageSubtitleColor:
      data.formPageSubtitleColor ||
      '#cccccc',

    formPageSubtitleFontSize:
      Number(
        data.formPageSubtitleFontSize ||
        16,
      ),

    formPageSubtitleFontWeight:
      data.formPageSubtitleFontWeight ||
      '400',

    formPageCardBackground:
      data.formPageCardBackground ||
      'rgba(15,15,15,.80)',

    formPageCardOpacity:
      Number(
        data.formPageCardOpacity ??
        100,
      ),

    formPageCardBorderColor:
      data.formPageCardBorderColor ||
      'rgba(255,255,255,.10)',

    formPageCardBorderWidth:
      Number(
        data.formPageCardBorderWidth ??
        1,
      ),

    formPageCardBorderRadius:
      Number(
        data.formPageCardBorderRadius ||
        24,
      ),

    formPageCardShadow:
      data.formPageCardShadow ??
      true,

    formPageCardWidth:
      Number(
        data.formPageCardWidth ||
        560,
      ),

    formPageCardPadding:
      Number(
        data.formPageCardPadding ||
        32,
      ),

    formPageCardPosition:
      data.formPageCardPosition ||
      'CENTER',

    formPageLabelColor:
      data.formPageLabelColor ||
      '#ffffff',

    formPageLabelFontSize:
      Number(
        data.formPageLabelFontSize ||
        14,
      ),

    formPageLabelFontWeight:
      data.formPageLabelFontWeight ||
      '700',

    formPageInputBackground:
      data.formPageInputBackground ||
      '#ffffff',

    formPageInputTextColor:
      data.formPageInputTextColor ||
      '#111827',

    formPageInputPlaceholderColor:
      data.formPageInputPlaceholderColor ||
      '#9ca3af',

    formPageInputBorderColor:
      data.formPageInputBorderColor ||
      '#d1d5db',

    formPageInputFocusColor:
      data.formPageInputFocusColor ||
      '#7c3aed',

    formPageInputBorderRadius:
      Number(
        data.formPageInputBorderRadius ||
        8,
      ),

    formPageInputHeight:
      Number(
        data.formPageInputHeight ||
        44,
      ),

    formPageInputFontSize:
      Number(
        data.formPageInputFontSize ||
        16,
      ),

    formPageConsentTextColor:
      data.formPageConsentTextColor ||
      '#cccccc',

    formPageButtonText:
      data.formPageButtonText ||
      'Começar jogo',

    formPageButtonColor:
      data.formPageButtonColor ||
      data.primaryColor ||
      '#7c3aed',

    formPageButtonTextColor:
      data.formPageButtonTextColor ||
      '#ffffff',

    formPageButtonHeight:
      Number(
        data.formPageButtonHeight ||
        54,
      ),

    formPageButtonBorderRadius:
      Number(
        data.formPageButtonBorderRadius ||
        10,
      ),
  })

  // ======================================================
  // APLICAR GAME CARREGADO
  // ======================================================

  const applyLoadedGame =
    async (
      loadedGame,
    ) => {
      const normalizedGame =
        normalizeGame(
          loadedGame,
        )

      setGame(
        normalizedGame,
      )

      sessionStorage.setItem(
        'games_fullscreen_enabled',
        normalizedGame
          .fullscreenEnabled ===
          true
          ? 'true'
          : 'false',
      )

      const idleScreenConfig = {
        gameId:
          normalizedGame.id,

        idleScreenEnabled:
          normalizedGame
            .idleScreenEnabled ===
          true,

        idleScreenDelay:
          Number(
            normalizedGame
              .idleScreenDelay ||
            30000,
          ),

        idleScreenShowBackground:
          normalizedGame
            .idleScreenShowBackground !==
          false,

        idleScreenBackgroundUrl:
          normalizedGame
            .idleScreenBackgroundUrl ||
          '',

        idleScreenShowVideo:
          normalizedGame
            .idleScreenShowVideo ===
          true,

        idleScreenVideoUrl:
          normalizedGame
            .idleScreenVideoUrl ||
          '',

        idleScreenMessage:
          normalizedGame
            .idleScreenMessage ||
          'Toque na tela para começar',

        idleScreenMessageColor:
          normalizedGame
            .idleScreenMessageColor ||
          '#ffffff',

        idleScreenMessageFontSize:
          Number(
            normalizedGame
              .idleScreenMessageFontSize ||
            48,
          ),

        idleScreenMessagePosition:
          normalizedGame
            .idleScreenMessagePosition ||
          'CENTER',

        idleScreenOverlayColor:
          normalizedGame
            .idleScreenOverlayColor ||
          '#000000',

        idleScreenOverlayOpacity:
          Number(
            normalizedGame
              .idleScreenOverlayOpacity ??
            20,
          ),
      }

      sessionStorage.setItem(
        'games_idle_screen_config',
        JSON.stringify(
          idleScreenConfig,
        ),
      )

      window.dispatchEvent(
        new CustomEvent(
          'games:idle-config-updated',
        ),
      )

      const storedLeadId =
        localStorage.getItem(
          `game_${normalizedGame.id}_lead_id`,
        )

      const storedLeadValues =
        localStorage.getItem(
          `game_${normalizedGame.id}_lead_values`,
        )

      if (storedLeadId) {
        setLeadId(
          storedLeadId,
        )
      } else {
        setLeadId(null)
      }

      if (
        storedLeadValues
      ) {
        try {
          setLeadValues(
            JSON.parse(
              storedLeadValues,
            ),
          )
        } catch (error) {
          localStorage.removeItem(
            `game_${normalizedGame.id}_lead_values`,
          )

          setLeadValues(null)
        }
      } else {
        setLeadValues(null)
      }

      return normalizedGame
    }

  // ======================================================
  // CARREGAR JOGO ONLINE / OFFLINE
  // ======================================================

  const loadGame = async () => {
    let data = null

    let loadedOffline =
      false

    let apiOnline =
      false

    try {
      apiOnline =
        await NetworkService
          .checkApiConnection()

      console.log(
        '[HYBRID] API REAL:',
        apiOnline
          ? 'ONLINE'
          : 'OFFLINE',
      )

      if (apiOnline) {
        try {
          data =
            await fetchWithTimeout(
              {
                url:
                  `/games/slug/${slug}`,

                method:
                  'get',

                silentNetworkError:
                  true,
              },
              2500,
            )

          await OfflineGameService
            .saveGame(
              data,
            )

          await OfflineGameService
            .saveMeta(
              `game:${data.id}:last-online-sync`,
              new Date().toISOString(),
            )

          console.log(
            '[HYBRID] Jogo carregado ONLINE e atualizado no IndexedDB:',
            data.id,
          )
        } catch (
        onlineError
        ) {
          console.warn(
            '[HYBRID] API indisponível. Tentando snapshot local...',
            onlineError,
          )
        }
      } else {
        console.log(
          '[HYBRID] API real indisponível. Usando snapshot local.',
        )
      }

      if (!data) {
        data =
          await OfflineGameService
            .getGameBySlug(
              slug,
            )

        loadedOffline =
          true

        if (!data) {
          throw new Error(
            'OFFLINE_GAME_NOT_FOUND',
          )
        }

        console.log(
          '[HYBRID] Jogo carregado do IndexedDB:',
          data.id,
        )
      }

      const normalizedGame =
        normalizeGame(
          data,
        )

      normalizedGame.offlineMode =
        loadedOffline

      setGame(
        normalizedGame,
      )

      sessionStorage.setItem(
        'games_fullscreen_enabled',

        normalizedGame
          .fullscreenEnabled ===
          true
          ? 'true'
          : 'false',
      )

      const idleScreenConfig = {
        gameId:
          normalizedGame.id,

        idleScreenEnabled:
          normalizedGame
            .idleScreenEnabled ===
          true,

        idleScreenDelay:
          Number(
            normalizedGame
              .idleScreenDelay ||
            30000,
          ),

        idleScreenShowBackground:
          normalizedGame
            .idleScreenShowBackground !==
          false,

        idleScreenBackgroundUrl:
          normalizedGame
            .idleScreenBackgroundUrl ||
          '',

        idleScreenShowVideo:
          normalizedGame
            .idleScreenShowVideo ===
          true,

        idleScreenVideoUrl:
          normalizedGame
            .idleScreenVideoUrl ||
          '',

        idleScreenMessage:
          normalizedGame
            .idleScreenMessage ||
          'Toque na tela para começar',

        idleScreenMessageColor:
          normalizedGame
            .idleScreenMessageColor ||
          '#ffffff',

        idleScreenMessageFontSize:
          Number(
            normalizedGame
              .idleScreenMessageFontSize ||
            48,
          ),

        idleScreenMessagePosition:
          normalizedGame
            .idleScreenMessagePosition ||
          'CENTER',

        idleScreenOverlayColor:
          normalizedGame
            .idleScreenOverlayColor ||
          '#000000',

        idleScreenOverlayOpacity:
          Number(
            normalizedGame
              .idleScreenOverlayOpacity ??
            20,
          ),
      }

      sessionStorage.setItem(
        'games_idle_screen_config',
        JSON.stringify(
          idleScreenConfig,
        ),
      )

      window.dispatchEvent(
        new CustomEvent(
          'games:idle-config-updated',
        ),
      )

      const storedLeadId =
        localStorage.getItem(
          `game_${data.id}_lead_id`,
        )

      const storedLeadValues =
        localStorage.getItem(
          `game_${data.id}_lead_values`,
        )

      setLeadId(
        storedLeadId ||
        null,
      )

      if (
        storedLeadValues
      ) {
        try {
          setLeadValues(
            JSON.parse(
              storedLeadValues,
            ),
          )
        } catch (error) {
          console.error(
            '[HYBRID] Dados locais do participante inválidos:',
            error,
          )

          localStorage.removeItem(
            `game_${data.id}_lead_values`,
          )

          setLeadValues(
            null,
          )
        }
      } else {
        setLeadValues(
          null,
        )
      }

      const activeLeadForm =
        await loadLeadForm(
          data.id,
        )

      const shouldShowLeadAfter =
        sessionStorage.getItem(
          `game_${data.id}_show_lead_after`,
        ) === 'true'

      const captureAfter =
        normalizedGame
          .leadCapturePosition ===
        'AFTER_GAME'

      setShowLeadAfterGame(
        Boolean(
          shouldShowLeadAfter &&
          captureAfter &&
          activeLeadForm,
        ),
      )

      console.log(
        loadedOffline
          ? '[HYBRID] Jogo pronto em modo OFFLINE'
          : '[HYBRID] Jogo pronto em modo ONLINE',
      )
    } catch (error) {
      console.error(
        '[HYBRID] Erro ao carregar jogo:',
        error,
      )

      if (
        error?.message ===
        'OFFLINE_GAME_NOT_FOUND'
      ) {
        message.error(
          'Este jogo não está disponível offline neste dispositivo.',
        )

        return
      }

      message.error(
        'Não foi possível iniciar o jogo.',
      )
    }
  }

  // ======================================================
  // INICIALIZAÇÃO
  // ======================================================

  useEffect(() => {
    loadGame()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug])

  // ======================================================
  // BLOQUEAR MENU DE CONTEXTO
  // ======================================================

  useEffect(() => {
    if (
      !game ||
      game.disableContextMenu !==
      true
    ) {
      return undefined
    }

    const handleContextMenu =
      (event) => {
        event.preventDefault()
      }

    document.addEventListener(
      'contextmenu',
      handleContextMenu,
    )

    return () => {
      document.removeEventListener(
        'contextmenu',
        handleContextMenu,
      )
    }
  }, [game])

  // ======================================================
  // CAMPOS DO FORMULÁRIO
  // ======================================================

  const renderLeadField = (
    field,
  ) => {
    const options =
      Array.isArray(
        field.options,
      )
        ? field.options.map(
          (item) => ({
            label:
              typeof item ===
                'object'
                ? item.label ||
                item.value
                : item,

            value:
              typeof item ===
                'object'
                ? item.value ||
                item.label
                : item,
          }),
        )
        : []

    const inputBackground =
      game
        ?.formPageInputBackground ||
      '#ffffff'

    const inputTextColor =
      game
        ?.formPageInputTextColor ||
      '#111827'

    const inputPlaceholderColor =
      game
        ?.formPageInputPlaceholderColor ||
      '#9ca3af'

    const inputFocusColor =
      game
        ?.formPageInputFocusColor ||
      '#7c3aed'

    const inputFontSize =
      Number(
        game
          ?.formPageInputFontSize ||
        16,
      )

    const inputBorderColor =
      game
        ?.formPageInputBorderColor ||
      '#d1d5db'

    const inputBorderRadius =
      Number(
        game
          ?.formPageInputBorderRadius ||
        8,
      )

    const inputHeight =
      Number(
        game
          ?.formPageInputHeight ||
        44,
      )

    const inputStyle = {
      width: '100%',

      minHeight:
        inputHeight,

      height:
        inputHeight,

      backgroundColor:
        inputBackground,

      color:
        inputTextColor,

      borderColor:
        inputBorderColor,

      borderRadius:
        inputBorderRadius,

      fontSize:
        inputFontSize,

      WebkitTextFillColor:
        inputTextColor,
    }

    const inputCssVariables = {
      '--form-input-background':
        inputBackground,

      '--form-input-text-color':
        inputTextColor,

      '--form-input-placeholder-color':
        inputPlaceholderColor,

      '--form-input-border-color':
        inputBorderColor,

      '--form-input-focus-color':
        inputFocusColor,

      '--form-input-border-radius':
        `${inputBorderRadius}px`,

      '--form-input-height':
        `${inputHeight}px`,

      '--form-input-font-size':
        `${inputFontSize}px`,
    }

    const commonInputProps = {
      autoComplete:
        'off',

      autoCorrect:
        'off',

      autoCapitalize:
        'none',

      spellCheck:
        false,

      name:
        `field_${field.id}_${Date.now()}`,
    }

    switch (
    field.fieldType
    ) {
      case 'EMAIL':
        return (
          <Input
            className="custom-form-input"
            size="large"
            type="text"
            inputMode="email"
            autoComplete="off"
            name={`email_${field.id}_${game.id}`}
            style={{
              ...inputStyle,
              ...inputCssVariables,
            }}
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck={
              false
            }
            placeholder={
              field.placeholder ||
              field.label
            }
          />
        )

      case 'PHONE':
        return (
          <Input
            className="custom-form-input"
            size="large"
            type="text"
            inputMode="tel"
            autoComplete="off"
            name={`phone_${field.id}_${game.id}`}
            style={{
              ...inputStyle,
              ...inputCssVariables,
            }}
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck={
              false
            }
            placeholder={
              field.placeholder ||
              field.label
            }
          />
        )

      case 'CPF':
        return (
          <Input
            className="custom-form-input"
            size="large"
            inputMode="numeric"
            maxLength={14}
            style={{
              ...inputStyle,
              ...inputCssVariables,
            }}
            {...commonInputProps}
            placeholder={
              field.placeholder ||
              field.label
            }
          />
        )

      case 'NUMBER':
        return (
          <InputNumber
            className="custom-form-input-number"
            size="large"
            style={{
              ...inputStyle,
              ...inputCssVariables,
            }}
            autoComplete="new-password"
            placeholder={
              field.placeholder ||
              field.label
            }
          />
        )

      case 'SELECT':
        return (
          <Select
            className="custom-form-select"
            size="large"
            style={{
              width:
                '100%',

              ...inputCssVariables,
            }}
            showSearch={
              false
            }
            filterOption={
              false
            }
            placeholder={
              field.placeholder ||
              field.label
            }
            options={
              options
            }
          />
        )

      case 'RADIO':
        return (
          <Radio.Group
            className="custom-form-radio"
            options={
              options
            }
            style={{
              color:
                inputTextColor,
            }}
          />
        )

      case 'CHECKBOX':
        return (
          <Checkbox.Group
            className="custom-form-checkbox"
            options={
              options
            }
            style={{
              color:
                inputTextColor,
            }}
          />
        )

      case 'TEXTAREA':
        return (
          <Input.TextArea
            className="custom-form-input"
            rows={4}
            {...commonInputProps}
            placeholder={
              field.placeholder ||
              field.label
            }
            style={{
              ...inputStyle,
              ...inputCssVariables,

              height:
                'auto',

              minHeight:
                inputHeight *
                2,
            }}
          />
        )

      case 'TEXT':
      default:
        return (
          <Input
            className="custom-form-input"
            size="large"
            style={{
              ...inputStyle,
              ...inputCssVariables,
            }}
            {...commonInputProps}
            placeholder={
              field.placeholder ||
              field.label
            }
          />
        )
    }
  }

  // ======================================================
  // SALVAR LEAD
  // ======================================================

  const handleSubmitLead =
    async () => {
      if (
        !game ||
        !leadForm
      ) {
        return false
      }

      try {
        const values =
          await leadCaptureForm
            .validateFields()

        const payloadValues =
          {}

          ; (
            leadForm.fields ||
            []
          ).forEach(
            (field) => {
              payloadValues[
                field.fieldKey
              ] =
                values[
                field.fieldKey
                ]
            },
          )

        const consentLgpd =
          values.consentLgpd ||
          false

        setLoadingLead(
          true,
        )

        let finalLeadId =
          null

        try {
          const data =
            await fetch({
              url:
                '/public/leads',

              method:
                'post',

              data: {
                formId:
                  leadForm.id,

                eventId:
                  game.eventId ||
                  game.event
                    ?.id ||
                  leadForm.eventId,

                gameId:
                  game.id,

                values:
                  payloadValues,

                consentLgpd,
              },

              silentNetworkError:
                true,
            })

          if (
            !data?.leadId
          ) {
            throw new Error(
              'LEAD_ID_NOT_RETURNED',
            )
          }

          finalLeadId =
            String(
              data.leadId,
            )

          console.log(
            '[LEAD] Cadastro salvo online:',
            finalLeadId,
          )
        } catch (
        onlineError
        ) {
          console.warn(
            '[LEAD] API indisponível. Salvando offline.',
            onlineError,
          )

          const offlineLead =
            await OfflineLeadService
              .createOfflineLead({
                game,

                leadForm,

                values:
                  payloadValues,

                consentLgpd,
              })

          if (
            !offlineLead
              ?.localId
          ) {
            throw new Error(
              'OFFLINE_LEAD_NOT_CREATED',
            )
          }

          finalLeadId =
            offlineLead.localId

          console.log(
            '[LEAD] Cadastro salvo offline:',
            finalLeadId,
          )
        }

        setLeadId(
          finalLeadId,
        )

        setLeadValues(
          payloadValues,
        )

        localStorage.setItem(
          `game_${game.id}_lead_id`,
          String(
            finalLeadId,
          ),
        )

        localStorage.setItem(
          `game_${game.id}_lead_values`,
          JSON.stringify(
            payloadValues,
          ),
        )

        sessionStorage.removeItem(
          `game_${game.id}_show_lead_after`,
        )

        sessionStorage.removeItem(
          `game_${game.id}_last_spin_id`,
        )

        message.success(
          'Cadastro realizado',
        )

        if (
          game.leadCapturePosition ===
          'AFTER_GAME'
        ) {
          setTimeout(
            () => {
              if (
                game.type ===
                'QUIZ'
              ) {
                resetQuizParticipant()

                window.setTimeout(
                  () => {
                    window.location.reload()
                  },
                  100,
                )

                return
              }

              resetParticipant()
            },
            1000,
          )
        }

        return true
      } catch (error) {
        console.error(
          '[LEAD] Erro ao cadastrar:',
          error,
        )

        const errorMessage =
          error?.response
            ?.data
            ?.message ||
          'Preencha os campos obrigatórios'

        message.error(
          errorMessage,
        )

        return false
      } finally {
        setLoadingLead(
          false,
        )
      }
    }

  // ======================================================
  // GIRO DA ROLETA
  // ======================================================

  const handleSpin =
    async () => {
      if (
        !game ||
        spinning ||
        !prizes.length
      ) {
        return
      }

      const spinDuration =
        Number(
          game.spinDuration ||
          5000,
        )

      window.dispatchEvent(
        new CustomEvent(
          'games:idle-pause',
        ),
      )

      setLoading(true)

      setSpinning(true)

      setShowCenterLogo(
        true,
      )

      try {
        const captureAfter =
          game.leadCapturePosition ===
          'AFTER_GAME'

        const participantData = {
          name:
            leadValues?.nome ||
            leadValues?.name ||
            leadValues
              ?.nome_completo ||
            (
              captureAfter
                ? undefined
                : 'Participante'
            ),

          phone:
            leadValues
              ?.telefone ||
            leadValues?.phone ||
            undefined,

          email:
            leadValues?.email ||
            undefined,

          cpf:
            leadValues?.cpf ||
            undefined,

          lgpdAccepted:
            Boolean(
              leadId,
            ) ||
            captureAfter,
        }

        let data =
          null

        let offlineSpin =
          false

        try {
          data =
            await fetch({
              url:
                '/spins',

              method:
                'post',

              silentNetworkError:
                true,

              data: {
                gameSlug:
                  game.slug,

                leadId,

                participant:
                  participantData,
              },
            })

          console.log(
            '[SPIN] Giro realizado ONLINE',
            data,
          )
        } catch (
        onlineError
        ) {
          console.warn(
            '[SPIN] API indisponível. Iniciando giro offline...',
            onlineError,
          )

          const localSpin =
            await OfflineSpinService
              .createOfflineSpin({
                game,

                leadId,

                participant:
                  participantData,
              })

          offlineSpin =
            true

          data = {
            id:
              localSpin.localId,

            localId:
              localSpin.localId,

            clientOperationId:
              localSpin
                .clientOperationId,

            gameId:
              localSpin.gameId,

            gameSlug:
              localSpin.gameSlug,

            prize:
              localSpin.prize,

            offline:
              true,

            syncStatus:
              localSpin
                .syncStatus,

            createdAt:
              localSpin.createdAt,
          }

          console.log(
            '[SPIN] Giro realizado OFFLINE',
            data,
          )
        }

        const prizeIndex =
          prizes.findIndex(
            (item) =>
              item.id ===
              data?.prize
                ?.id,
          )

        const slice =
          360 /
          prizes.length

        const safePrizeIndex =
          prizeIndex >= 0
            ? prizeIndex
            : Math.floor(
              Math.random() *
              prizes.length,
            )

        const targetAngle =
          360 -
          safePrizeIndex *
          slice -
          slice /
          2

        setRotation(
          (old) =>
            old +
            1800 +
            targetAngle,
        )

        setTimeout(
          () => {
            setSpinning(
              false,
            )

            const hasActiveAfterForm =
              Boolean(
                leadForm,
              ) &&
              game.leadCapturePosition ===
              'AFTER_GAME'

            if (
              hasActiveAfterForm
            ) {
              sessionStorage.setItem(
                `game_${game.id}_show_lead_after`,
                'true',
              )

              sessionStorage.setItem(
                `game_${game.id}_last_spin_id`,
                data.id,
              )
            } else {
              sessionStorage.removeItem(
                `game_${game.id}_show_lead_after`,
              )

              sessionStorage.removeItem(
                `game_${game.id}_last_spin_id`,
              )
            }

            if (
              offlineSpin
            ) {
              sessionStorage.setItem(
                `game_${game.id}_last_spin_offline`,
                'true',
              )
            } else {
              sessionStorage.removeItem(
                `game_${game.id}_last_spin_offline`,
              )
            }

            window.dispatchEvent(
              new CustomEvent(
                'games:idle-resume',
              ),
            )

            navigate(
              `/p/${data.id}`,
            )
          },
          spinDuration +
          500,
        )
      } catch (error) {
        const errorMessage =
          error?.response
            ?.data
            ?.message ||
          error?.message ||
          'Erro ao girar roleta'

        setSpinning(
          false,
        )

        setLoading(
          false,
        )

        setShowCenterLogo(
          false,
        )

        window.dispatchEvent(
          new CustomEvent(
            'games:idle-resume',
          ),
        )

        Modal.error({
          title:
            'Participação não permitida',

          content:
            errorMessage,

          okText:
            'Novo participante',

          centered:
            true,

          onOk:
            resetParticipant,
        })
      } finally {
        setLoading(false)
      }
    }

  // ======================================================
  // FINALIZAÇÃO DO JOGO DA MEMÓRIA
  // ======================================================

  const handleMemoryFinished = (
    result,
  ) => {
    console.log(
      '[MEMORY] Partida finalizada:',
      result,
    )

    window.dispatchEvent(
      new CustomEvent(
        'games:idle-resume',
      ),
    )

    const hasActiveAfterForm =
      Boolean(leadForm) &&
      game?.leadCapturePosition ===
      'AFTER_GAME'

    if (hasActiveAfterForm) {
      setShowLeadAfterGame(
        true,
      )

      sessionStorage.setItem(
        `game_${game.id}_show_lead_after`,
        'true',
      )
    }
  }

  // ======================================================
  // FINALIZAÇÃO DO QUIZ
  // ======================================================

  const handleQuizFinished = (
    result,
  ) => {
    console.log(
      '[QUIZ] Partida finalizada:',
      result,
    )

    window.dispatchEvent(
      new CustomEvent(
        'games:idle-resume',
      ),
    )

    const hasActiveAfterForm =
      Boolean(leadForm) &&
      game?.leadCapturePosition ===
      'AFTER_GAME'

    // ====================================================
    // FORMULÁRIO DEPOIS DO JOGO
    // ====================================================
    //
    // IMPORTANTE:
    //
    // Se o formulário é AFTER_GAME, NÃO limpamos o lead
    // aqui. O participante ainda precisa preencher e
    // enviar o formulário.
    //
    // A limpeza será feita somente depois que o formulário
    // for enviado com sucesso.
    // ====================================================

    if (hasActiveAfterForm) {
      console.log(
        '[QUIZ] Abrindo formulário pós-jogo.',
      )

      setShowLeadAfterGame(
        true,
      )

      sessionStorage.setItem(
        `game_${game.id}_show_lead_after`,
        'true',
      )

      return
    }

    // ====================================================
    // SEM FORMULÁRIO AFTER_GAME
    // ====================================================

    resetQuizParticipant()

    window.setTimeout(
      () => {
        window.location.reload()
      },
      100,
    )
  }

  // ======================================================
  // TELA DE CAPTAÇÃO
  // ======================================================

  const renderLeadCaptureScreen =
    ({
      afterGame = false,
    } = {}) => {
      if (
        !leadForm ||
        !game
      ) {
        return null
      }

      const backgroundUrl =
        game.formPageBackgroundUrl ||
        null

      const backgroundColor =
        game.formPageBackgroundColor ||
        '#15112f'

      const overlayColor =
        game.formPageOverlayColor ||
        '#000000'

      const overlayOpacity =
        Math.min(
          100,
          Math.max(
            0,
            Number(
              game.formPageOverlayOpacity ??
              45,
            ),
          ),
        ) /
        100

      const backgroundBlur =
        Math.max(
          0,
          Number(
            game.formPageBackgroundBlur ||
            0,
          ),
        )

      const logoUrl =
        game.formPageLogoUrl ||
        game.logoUrl

      const title =
        afterGame
          ? leadForm.name ||
          game.formPageTitle ||
          'Complete seu cadastro'
          : game.formPageTitle ||
          leadForm.name ||
          'Cadastre-se'

      const subtitle =
        afterGame
          ? leadForm.description ||
          'Preencha seus dados para finalizar sua participação.'
          : game.formPageSubtitle ||
          leadForm.description ||
          'Preencha seus dados para participar'

      const buttonText =
        afterGame
          ? 'Finalizar cadastro'
          : game.formPageButtonText ||
          'Começar jogo'

      const cardWidth =
        Number(
          game.formPageCardWidth ||
          560,
        )

      const cardPadding =
        Number(
          game.formPageCardPadding ||
          32,
        )

      const cardPosition =
        game.formPageCardPosition ||
        'CENTER'

      const cardVerticalAlignment =
        cardPosition ===
          'TOP'
          ? 'flex-start'
          : cardPosition ===
            'BOTTOM'
            ? 'flex-end'
            : 'center'

      const cardOpacity =
        Math.min(
          100,
          Math.max(
            0,
            Number(
              game.formPageCardOpacity ??
              100,
            ),
          ),
        ) /
        100

      const cardBackground =
        game.formPageCardBackground ||
        'rgba(15,15,15,.80)'

      return (
        <div
          className="form-page-scroll-container"
          style={{
            position:
              'relative',

            width:
              '100%',

            height:
              '100dvh',

            minHeight:
              '100vh',

            display:
              'flex',

            flexDirection:
              'column',

            alignItems:
              'center',

            justifyContent:
              cardVerticalAlignment,

            padding:
              'clamp(20px, 4vh, 48px) clamp(16px, 3vw, 32px)',

            boxSizing:
              'border-box',

            overflowX:
              'hidden',

            overflowY:
              'auto',

            scrollbarWidth:
              'none',

            msOverflowStyle:
              'none',
          }}
        >
          <div
            style={{
              position:
                'fixed',

              inset:
                backgroundBlur
                  ? -backgroundBlur *
                  2
                  : 0,

              zIndex:
                0,

              backgroundColor,

              backgroundImage:
                backgroundUrl
                  ? `url(${getImageUrl(
                    backgroundUrl,
                  )})`
                  : 'none',

              backgroundPosition:
                'center',

              backgroundRepeat:
                'no-repeat',

              backgroundSize:
                'cover',

              filter:
                backgroundBlur >
                  0
                  ? `blur(${backgroundBlur}px)`
                  : 'none',

              transform:
                backgroundBlur >
                  0
                  ? 'scale(1.04)'
                  : 'none',

              pointerEvents:
                'none',
            }}
          />

          <div
            style={{
              position:
                'fixed',

              inset:
                0,

              zIndex:
                1,

              background:
                `rgba(${hexToRgb(
                  overlayColor,
                )}, ${overlayOpacity})`,

              pointerEvents:
                'none',
            }}
          />

          <div
            className="lead-card"
            style={{
              position:
                'relative',

              zIndex:
                2,

              width:
                `min(${cardWidth}px, calc(100% - 32px))`,

              maxWidth:
                '100%',

              flexShrink:
                0,

              padding:
                cardPadding,

              boxSizing:
                'border-box',

              background:
                cardBackground,

              opacity:
                cardOpacity,

              border:
                `${Number(
                  game.formPageCardBorderWidth ??
                  1,
                )}px solid ${game.formPageCardBorderColor ||
                'rgba(255,255,255,.10)'
                }`,

              borderRadius:
                Number(
                  game.formPageCardBorderRadius ||
                  24,
                ),

              boxShadow:
                game.formPageCardShadow !==
                  false
                  ? '0 24px 80px rgba(0,0,0,.40)'
                  : 'none',

              backdropFilter:
                'blur(10px)',

              WebkitBackdropFilter:
                'blur(10px)',
            }}
          >
            {game.formPageShowLogo !==
              false &&
              logoUrl && (
                <div
                  style={{
                    display:
                      'flex',

                    justifyContent:
                      game.formPageLogoHorizontalPosition ===
                        'LEFT'
                        ? 'flex-start'
                        : game.formPageLogoHorizontalPosition ===
                          'RIGHT'
                          ? 'flex-end'
                          : 'center',

                    marginBottom:
                      22,
                  }}
                >
                  <img
                    src={getImageUrl(
                      logoUrl,
                    )}
                    alt="Logo"
                    draggable={
                      false
                    }
                    style={{
                      width:
                        Number(
                          game.formPageLogoSize ||
                          180,
                        ),

                      maxWidth:
                        '80%',

                      maxHeight:
                        Number(
                          game.formPageLogoSize ||
                          180,
                        ),

                      objectFit:
                        'contain',

                      userSelect:
                        'none',
                    }}
                  />
                </div>
              )}

            {game.formPageShowTitle !==
              false && (
                <Title
                  level={2}
                  style={{
                    marginTop:
                      0,

                    marginBottom:
                      8,

                    textAlign:
                      'center',

                    color:
                      game.formPageTitleColor ||
                      '#ffffff',

                    fontSize:
                      Number(
                        game.formPageTitleFontSize ||
                        32,
                      ),

                    fontWeight:
                      game.formPageTitleFontWeight ||
                      '800',

                    lineHeight:
                      1.15,
                  }}
                >
                  {title}
                </Title>
              )}

            {game.formPageShowSubtitle !==
              false &&
              subtitle && (
                <div
                  style={{
                    textAlign:
                      'center',

                    color:
                      game.formPageSubtitleColor ||
                      '#cccccc',

                    fontSize:
                      Number(
                        game.formPageSubtitleFontSize ||
                        16,
                      ),

                    fontWeight:
                      game.formPageSubtitleFontWeight ||
                      '400',

                    lineHeight:
                      1.4,

                    marginBottom:
                      24,
                  }}
                >
                  {subtitle}
                </div>
              )}

            <Form
              form={
                leadCaptureForm
              }
              layout="vertical"
              autoComplete="off"
              name={`lead_form_${game.id}`}
            >
              {(
                leadForm.fields ||
                []
              ).map(
                (field) => (
                  <Form.Item
                    key={
                      field.id
                    }
                    name={
                      field.fieldKey
                    }
                    label={
                      <span
                        style={{
                          color:
                            game.formPageLabelColor ||
                            '#ffffff',

                          fontSize:
                            Number(
                              game.formPageLabelFontSize ||
                              14,
                            ),

                          fontWeight:
                            game.formPageLabelFontWeight ||
                            '700',
                        }}
                      >
                        {
                          field.label
                        }
                      </span>
                    }
                    rules={[
                      {
                        required:
                          field.isRequired,

                        message:
                          `Informe ${field.label}`,
                      },
                    ]}
                  >
                    {renderLeadField(
                      field,
                    )}
                  </Form.Item>
                ),
              )}

              {leadForm.requireConsent && (
                <Form.Item
                  name="consentLgpd"
                  valuePropName="checked"
                  rules={[
                    {
                      validator:
                        (
                          _,
                          value,
                        ) => {
                          if (
                            value
                          ) {
                            return Promise.resolve()
                          }

                          return Promise.reject(
                            new Error(
                              'Aceite os termos',
                            ),
                          )
                        },
                    },
                  ]}
                >
                  <Checkbox
                    style={{
                      color:
                        game.formPageConsentTextColor ||
                        '#cccccc',
                    }}
                  >
                    {leadForm.consentText ||
                      'Autorizo o uso dos meus dados para contato e ações promocionais.'}
                  </Checkbox>
                </Form.Item>
              )}

              <Button
                type="primary"
                size="large"
                block
                htmlType="button"
                loading={
                  loadingLead
                }
                onClick={
                  handleSubmitLead
                }
                style={{
                  height:
                    Number(
                      game.formPageButtonHeight ||
                      54,
                    ),

                  fontSize:
                    18,

                  fontWeight:
                    800,

                  color:
                    game.formPageButtonTextColor ||
                    '#ffffff',

                  background:
                    game.formPageButtonColor ||
                    '#7c3aed',

                  borderColor:
                    game.formPageButtonColor ||
                    '#7c3aed',

                  borderRadius:
                    Number(
                      game.formPageButtonBorderRadius ||
                      10,
                    ),

                  boxShadow:
                    'none',
                }}
              >
                {
                  buttonText
                }
              </Button>
            </Form>
          </div>
        </div>
      )
    }

  // ======================================================
  // CARREGANDO
  // ======================================================

  if (!game) {
    return (
      <div
        style={{
          padding: 40,
        }}
      >
        <Title>
          Carregando jogo...
        </Title>
      </div>
    )
  }

  // ======================================================
  // TELA INICIAL / JOGAR
  // ======================================================

  const shouldShowStartScreen =
    game?.type ===
    'MEMORY' &&
    showStartScreen

  if (
    shouldShowStartScreen
  ) {
    return (
      <GameStartScreen
        game={
          game
        }
        onStart={
          handleEnterGame
        }
      />
    )
  }

  // ======================================================
  // FORMULÁRIO ANTES DO JOGO
  // ======================================================

  const showLeadBeforeGame =
    Boolean(
      leadForm,
    ) &&
    game.leadCapturePosition !==
    'AFTER_GAME' &&
    !leadId

  if (
    showLeadBeforeGame
  ) {
    return renderLeadCaptureScreen({
      afterGame:
        false,
    })
  }

  // ======================================================
  // FORMULÁRIO DEPOIS DO JOGO
  // ======================================================

  const shouldShowLeadAfterGame =
    Boolean(showLeadAfterGame) &&
    Boolean(leadForm) &&
    game.leadCapturePosition ===
    'AFTER_GAME'

  if (shouldShowLeadAfterGame) {
    return renderLeadCaptureScreen({
      afterGame: true,
    })
  }

  // ======================================================
  // DISPATCHER DOS JOGOS
  // ======================================================

  switch (game.type) {
    case 'MEMORY':
      return (
        <MemoryGame
          game={game}
          leadId={leadId}
          leadValues={leadValues}
          onGameFinished={
            handleMemoryFinished
          }
        />
      )

    case 'QUIZ':
      return (
        <QuizGame
          game={game}
          leadId={leadId}
          leadValues={leadValues}
          onGameFinished={
            handleQuizFinished
          }
        />
      )

    case 'ROULETTE':
      return (
        <RouletteGame
          game={game}
          prizes={prizes}
          loading={loading}
          spinning={spinning}
          rotation={rotation}
          showCenterLogo={
            showCenterLogo
          }
          onSpin={
            handleSpin
          }
          apiBaseUrl={
            API_BASE_URL
          }
        />
      )

    default:
      return (
        <div
          style={{
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 30,
            textAlign: 'center',
          }}
        >
          <div>
            <Title level={2}>
              Tipo de jogo não suportado
            </Title>

            <div>
              Tipo: {game.type}
            </div>
          </div>
        </div>
      )
  }
}

export default PlayPage